import styled from 'styled-components/macro'

export const Main = styled.main`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  width: 100%;
`
